import { useRef, useState } from "react";
import { writeToClipboard } from "../lib/writeToClipboard";
import { AnimatedCopyIcon } from "./AnimatedCopyIcon";
import { ToggleButton } from "./HeadingToggle";
import { Tooltip } from "./Tooltip";

export function CopyToggleButton({
  getText,
}: {
  getText: () => string | null | undefined;
}) {
  const [copied, setCopied] = useState(false);
  const timeout = useRef<ReturnType<typeof setTimeout>>(undefined);
  const copy = () => {
    const text = getText();
    if (!text) return;
    void writeToClipboard(text);
    setCopied(true);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => setCopied(false), 1500);
  };
  return (
    <Tooltip content={copied ? "Copied" : "Copy"}>
      <ToggleButton onPress={copy}>
        <AnimatedCopyIcon copied={copied} />
      </ToggleButton>
    </Tooltip>
  );
}
